module.exports = __webpack_public_path__ + "images/emoji/underage.aa813f6eedbdf051bf8c.png";